import React, { useEffect, useState } from "react";
import { OnboardingPageStructure } from "js/react/views/Onboarding/Components/Shared";

async function loadOnboardingPage() {
    // @ts-ignore
    const { default: OnboardingPage } = await import(/* webpackChunkName: "onboarding" */ "js/react/views/Onboarding/Onboarding");

    return OnboardingPage;
}

async function initFirebase() {
    const [
        { init },
    ] = await Promise.all([
        // @ts-ignore
        import(/* webpackChunkName: "onboarding-firebase-init" */ "js/firebase/init"),
    ]);
    await init();
}

async function initI18n() {
    const [
        { initI18n },
        { getInitialLocale }
    ] = await Promise.all([
        // @ts-ignore
        import(/* webpackChunkName: "onboarding-i18n" */ "js/i18n"),
        // @ts-ignore
        import(/* webpackChunkName: "onboarding-locale" */ "js/i18n/locale"),
    ]);

    initI18n(getInitialLocale());
}

async function loadInitializedOnboardingPage() {
    // Firebase must be initialized before any other module is evaluated: importing
    // the onboarding graph can call auth() (e.g. via the logger), and auth() will
    // silently bind to a throwaway test app if no real Firebase app exists yet.
    await initFirebase();

    const [OnboardingPage] = await Promise.all([
        loadOnboardingPage(),
        initI18n(),
    ]);

    return OnboardingPage;
}

function LoadingState() {
    return (<OnboardingPageStructure initialized={false} />);
}

export function EntryPoint() {
    const [OnboardingPage, setOnboardingPage] = useState<React.ComponentType | null>(null);

    useEffect(() => {
        let mounted = true;
        loadInitializedOnboardingPage()
            .then(LoadedOnboardingPage => {
                if (mounted) {
                    setOnboardingPage(() => LoadedOnboardingPage);
                }
            })
            .catch(err => {
                console.error(err);
            });
    }, []);

    if (!OnboardingPage) {
        return <LoadingState />;
    }

    return <OnboardingPage />;
}
